import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ToWords } from 'to-words';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as moment from 'moment';





@Component({
  selector: 'app-view-issue-seller-invoice',
  standalone: false,
  
  templateUrl: './view-issue-seller-invoice.component.html',
  styleUrl: './view-issue-seller-invoice.component.scss'
})
export class ViewIssueSellerInvoiceComponent {
   viewData;
    isLoading = false;
  
    filteredShowData = [];
  showData: any;
  
    constructor(
      private dialogRef: MatDialogRef<ViewIssueSellerInvoiceComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService
    ) {}
  
    ngOnInit(): void {
      this.isLoading = false;
      debugger
      this.viewData = this.data['advtData'];
      debugger
      // console.log(this.viewData);
  
      this.setData();
    }
  
    issueName: any;
    percentage:any=0



  //   getEmptyWeekData() {
  //   return {
  //     id: 0,
  //     issue_date: '',
  //     advt_size: 0,
  //     page_no: 0,
  //     hsn: '-',
  //     advt_rate: 0,
  //     dis: Number(0),
  //     net: 0,
  //     cgst: 0,
  //     sgst: 0,
  //     igst: 0,
  //     round_off: 0,
  //     total: 0,
  //     issueName:'',
  //     issue_copies:Number(0),
  //     issue_seller_price:Number(0),
  //     net_amount:Number(0),
  //     total_amount:0,
  //     issue_total_price:0,
      
  //   };
  // }
    setData() {
      if (!this.viewData) {
        this.isLoading = false;
        alert('Data is not Present.');
        this.dialogRef.close();
      }
      if (Object.keys(this.viewData).length > 0) {
        // console.log('called', this.viewData);
  
        for (let index = 0; index < this.viewData.length; index++) {
          let showData:any = {
            invoice_no: '',
            invoice_date: '',
            issueName: '',
            issue_seller_name: '',
            opening_bal:'',
            address: '',
            state: '',
            percentage1:this.viewData[index].percentage1,
            per:this.viewData[index].per,
            advt_order_no: '',
            advt_order_date: '',
            firstweek: {
              id: 0,
              issue_date: '',
              advt_size: '',
              page_no: '',
              hsn: '',
              advt_rate: '',
              price:'',
              dis: '',
              net: '',
              cgst: 0,
              sgst: 0,
              igst: 0,
              round_off: 0,
              total: 0,
              ro_no:'',
              ro_date:'',
              gst_type:'',
              issueName: '',
            },
            secondweek: {
              id: 0,
              issue_date: '',
              advt_size: '',
              price:'',
              page_no: '',
              hsn: '',
              advt_rate: '',
              dis: '',
              net: '',
              cgst: 0,
              sgst: 0,
              igst: 0,
              round_off: '',
              total: '',
              ro_no:'',
              ro_date:'',
              gst_type:'',
              issueName: '',
            },
            thirdweek: {
              id: 0,
              issue_date: '',
              advt_size: '',
              price:'',
              page_no: '',
              hsn: '',
              advt_rate: '',
              dis: '',
              net: '',
              cgst: 0,
              sgst: 0,
              igst: 0,
              round_off: '',
              total: '',
              ro_no:'',
              ro_date:'',
              gst_type:'',
              issueName: '',
            },
            fourthweek: {
              id: 0,
              issue_date: '',
              advt_size: '',
              price:'',
              page_no: '',
              hsn: '',
              advt_rate: '',
              dis: '',
              net: '',
              cgst: 0,
              sgst: 0,
              igst: 0,
              round_off: '',
              total: '',
              ro_no:'',
              ro_date:'',
              gst_type:'',
              issueName: '',
            },
            fifthweek: {
              id: 0,
              issue_date: '',
              price:'',
              advt_size: '',
              page_no: '',
              hsn: '',
              advt_rate: '',
              dis: '',
              net: '',
              cgst: 0,
              sgst: 0,
              igst: 0,
              round_off: '',
              total: '',
              ro_no:'',
              ro_date:'',
              gst_type:'',
              issueName: '',
            },
            total_amt: {
              page_no: 0,
              advt_rate: 0,
              dis: 0,
              net: 0,
              cgst: 0,
              sgst: 0,
              igst: 0,
              round_off: 0,
              total: 0,
            },
            total_in_words: '',
            pre_bal: 0,
            
            total: 0,
            remaining_amt: 0,
          };
          this.service
            .getBasicInfoOfissueInvoice(
              this.viewData[index]['first_week_id'] ??
                this.viewData[index]['second_week_id'] ??
                this.viewData[index]['third_week_id'] ??
                this.viewData[index]['fourth_week_id'] ??
                this.viewData[index]['fifth_week_id']
            )
            .subscribe((res) => {
              // console.log(res);
              showData['advt_order_no'] = res[0]['booking_no'];
              showData['advt_order_date'] = res[0]['booking_date'];
              showData['cust_name'] = res[0]['cust_name'];
              showData['ro_no'] = res[0]['ro_no'];
              showData['ro_date'] = res[0]['ro_date'];
              showData['cust_gst_no'] = res[0]['gstno'];
              showData['address'] = res[0]['address'];
              showData['state'] = res[0]['state'];
              // showData['issueName'] = res[0]['issueName'];
            });
  
          showData['issue_seller_name'] = this.viewData[index]['issue_seller_name'];
          showData['invoice_no'] = this.viewData[index]['invoice_no'];
          showData['invoice_date'] = this.viewData[index]['invoice_date'];
          showData['opening_bal'] = this.viewData[index]['opening_bal'];
  
  
          // for (let index = 0; index < this.viewData[index].length; index++) {
          // let issuedate = this.viewData[index]['DS_ISSUEDATE'].split(',')[0];
  
          // showData['total_in_words'] = new ToWords().convert(
          //   showData['total_amt']['total'],
          //   {
          //     currency: true,
          //   }
          // );
          // showData['pre_bal'] = ;
          // showData['total'] = showData['total_amt']['total'];
          // showData['remaining_amt'] =
          //   showData['pre_bal'] + showData['total'];
          debugger
          if (this.viewData[index]['first_week_id'] != null) {
            debugger
            console.log('first', parseInt(this.viewData[index]['first_week_id']));
            this.percentage= parseFloat(this.viewData[index]['first_week_percentage'])
            showData['firstweek']['id'] = this.viewData[index]['first_week_id'];
            showData['firstweek']['issue_date'] =
              this.viewData[index]['first_week_issue_date'];
              showData['firstweek']['issueName'] =
              this.viewData[index]['first_week_issue_name'];
            showData['firstweek']['advt_size'] =
              this.viewData[index]['first_week_advt_size'];
            showData['firstweek']['page_no'] =
              this.viewData[index]['first_week_pages_no'];
            showData['firstweek']['hsn'] = '998363';
            showData['firstweek']['advt_rate'] =
              this.viewData[index]['first_week_advt_amt'];
            showData['firstweek']['dis'] =
              this.viewData[index]['first_week_advt_discnt'];
            showData['firstweek']['net'] =
              this.viewData[index]['first_week_amount'];
              showData['firstweek']['price'] =
              this.viewData[index]['first_week_total'];
            showData['firstweek']['cgst'] = this.viewData[index]['first_week_cgst'];
            showData['firstweek']['sgst'] =
             this.viewData[index]['first_week_sgst'];
            showData['firstweek']['gst_type'] =
            this.viewData[index]['first_gst_include_exclude'];
            showData['firstweek']['igst'] =
              Number(this.viewData[index]['first_week_igst']);
            showData['firstweek']['round_off'] =
              this.viewData[index]['first_week_total_amount'];
            showData['firstweek']['total'] =
              this.viewData[index]['first_week_total_amount'];
              showData['firstweek']['issue_seller_price'] =
              this.viewData[index]['first_week_total'];
            showData['total_amt']['page_no'] += parseInt(
              this.viewData[index]['first_week_pages_no']
            );
            showData['total_amt']['advt_rate'] += parseInt(
              this.viewData[index]['first_week_advt_amt']
            );
            showData['total_amt']['dis'] += parseInt(
              this.viewData[index]['first_week_advt_discnt']
            );
            showData['total_amt']['net'] += parseInt(
              this.viewData[index]['first_week_amount']
            );
          debugger
            showData['total_amt']['cgst'] += parseInt(
              this.viewData[index]['first_week_cgst']
            )/this.percentage;
            showData['total_amt']['sgst'] += parseInt(
              this.viewData[index]['first_week_sgst']
            )/this.percentage;
            showData['total_amt']['igst'] += parseInt(
              this.viewData[index]['first_week_igst']
            );
            showData['total_amt']['round_off'] += parseInt(
              this.viewData[index]['first_week_total_amount']
            );
            showData['total_amt']['total'] += parseInt(
              this.viewData[index]['first_week_total_amount']
            );
          } 
           if (this.viewData[index]['second_week_id'] != null) {
            
            this.percentage= parseFloat(this.viewData[index]['second_week_percentage'])
            showData['secondweek']['id'] = this.viewData[index]['second_week_id'];
            showData['secondweek']['issue_date'] =
              this.viewData[index]['second_week_issue_date'];
              showData['secondweek']['issueName'] =
              this.viewData[index]['second_week_issue_name'];
            showData['secondweek']['advt_size'] =
              this.viewData[index]['second_week_advt_size'];
            showData['secondweek']['page_no'] =
              this.viewData[index]['second_week_pages_no'];
            showData['secondweek']['hsn'] = '998363';
            showData['secondweek']['advt_rate'] =
              this.viewData[index]['second_week_advt_amt'];
            showData['secondweek']['dis'] =
              this.viewData[index]['second_week_advt_discnt'];
            showData['secondweek']['net'] =
              this.viewData[index]['second_week_amount'];
              showData['secondweek']['price'] =
              this.viewData[index]['second_week_total'];
            showData['secondweek']['cgst'] =
              this.viewData[index]['second_week_cgst'];
              showData['secondweek']['gst_type'] =
              this.viewData[index]['second_gst_include_exclude'];
            showData['secondweek']['sgst'] =
             this.viewData[index]['second_week_sgst'];
            showData['secondweek']['igst'] =
           this.viewData[index]['second_week_igst'];
            showData['secondweek']['round_off'] =
              this.viewData[index]['second_week_total_amount'];
            showData['secondweek']['total'] =
              this.viewData[index]['second_week_total_amount'];
  
            showData['total_amt']['page_no'] += parseInt(
              this.viewData[index]['second_week_pages_no']
            );
            showData['total_amt']['advt_rate'] += parseInt(
              this.viewData[index]['second_week_advt_amt']
            );
            showData['total_amt']['dis'] += parseInt(
              this.viewData[index]['second_week_advt_discnt']
            );
            showData['total_amt']['net'] += parseInt(
              this.viewData[index]['second_week_amount']
            );
            showData['total_amt']['cgst'] += parseInt(
              this.viewData[index]['second_week_cgst']
            )/this.percentage;
            showData['total_amt']['sgst'] += parseInt(
              this.viewData[index]['second_week_sgst']
            )/this.percentage;
            showData['total_amt']['igst'] += parseInt(
              this.viewData[index]['second_week_igst']
            );
            showData['total_amt']['round_off'] += parseInt(
              this.viewData[index]['second_week_total_amount']
            );
            showData['total_amt']['total'] += parseInt(
              this.viewData[index]['second_week_total_amount']
            );
          } 
           if (this.viewData[index]['third_week_id'] != null) {
            
            this.percentage= parseFloat(this.viewData[index]['third_week_percentage'])
            showData['thirdweek']['id'] = this.viewData[index]['third_week_id'];
            showData['thirdweek']['issue_date'] =
              this.viewData[index]['third_week_issue_date'];
              showData['thirdweek']['issueName'] =
              this.viewData[index]['third_week_issue_name'];
            showData['thirdweek']['advt_size'] =
              this.viewData[index]['third_week_advt_size'];
            showData['thirdweek']['page_no'] =
              this.viewData[index]['third_week_pages_no'];
            showData['thirdweek']['hsn'] = '998363';
            showData['thirdweek']['advt_rate'] =
              this.viewData[index]['third_week_advt_amt'];
            showData['thirdweek']['dis'] =
              this.viewData[index]['third_week_advt_discnt'];

            showData['thirdweek']['net'] =
              this.viewData[index]['third_week_amount'];
               showData['thirdweek']['price'] =
              this.viewData[index]['third_week_total'];
            showData['thirdweek']['cgst'] =
              this.viewData[index]['third_week_cgst'];
            showData['thirdweek']['sgst'] =
              this.viewData[index]['third_week_sgst'];
              showData['thirdweek']['gst_type'] =
              this.viewData[index]['third_gst_include_exclude'];
            showData['thirdweek']['igst'] =
            this.viewData[index]['third_week_igst'];
            showData['thirdweek']['round_off'] =
              this.viewData[index]['third_week_total_amount'];
            showData['thirdweek']['total'] =
              this.viewData[index]['third_week_total_amount'];
  
            showData['total_amt']['page_no'] += parseInt(
              this.viewData[index]['third_week_pages_no']
            );
            showData['total_amt']['advt_rate'] += parseInt(
              this.viewData[index]['third_week_advt_amt']
            );
            showData['total_amt']['dis'] += parseInt(
              this.viewData[index]['third_week_advt_discnt']
            );
            showData['total_amt']['net'] += parseInt(
              this.viewData[index]['third_week_amount']
            );
            showData['total_amt']['cgst'] += parseInt(
              this.viewData[index]['third_week_cgst']
            )/this.percentage;
            showData['total_amt']['sgst'] += parseInt(
              this.viewData[index]['third_week_sgst']
            )/this.percentage;
            showData['total_amt']['igst'] += parseInt(
              this.viewData[index]['third_week_igst']
            );
            showData['total_amt']['round_off'] += parseInt(
              this.viewData[index]['third_week_total_amount']
            );
            showData['total_amt']['total'] += parseInt(
              this.viewData[index]['third_week_total_amount']
            );
          } 
           if (this.viewData[index]['fourth_week_id'] != null) {
            this.percentage= parseFloat(this.viewData[index]['fourth_week_percentage'])
            showData['fourthweek']['id'] = this.viewData[index]['fourth_week_id'];
            debugger
            showData['fourthweek']['issue_date'] =
              this.viewData[index]['fourth_week_issue_date'];
              
              showData['fourthweek']['issueName'] =
              this.viewData[index]['fourth_week_issue_name'];
            showData['fourthweek']['advt_size'] =
              this.viewData[index]['fourth_week_advt_size'];
            showData['fourthweek']['page_no'] =
              this.viewData[index]['fourth_week_pages_no'];
            showData['fourthweek']['hsn'] = '998363';
            showData['fourthweek']['advt_rate'] =
              this.viewData[index]['fourth_week_advt_amt'];
            showData['fourthweek']['dis'] =
              this.viewData[index]['fourth_week_advt_discnt'];
            showData['fourthweek']['net'] =
              this.viewData[index]['fourth_week_amount'];
               showData['fourthweek']['price'] =
              this.viewData[index]['fourth_week_total'];
            showData['fourthweek']['cgst'] =
              this.viewData[index]['fourth_week_cgst'];
            showData['fourthweek']['sgst'] =
              this.viewData[index]['fourth_week_sgst'];
              showData['fourthweek']['gst_type'] =
              this.viewData[index]['fourth_gst_include_exclude'];
            showData['fourthweek']['igst'] =
            this.viewData[index]['fourth_week_igst'];
            showData['fourthweek']['round_off'] =
              this.viewData[index]['fourth_week_total_amount'];
            showData['fourthweek']['total'] =
              this.viewData[index]['fourth_week_total_amount'];
  
            showData['total_amt']['page_no'] += parseInt(
              this.viewData[index]['fourth_week_pages_no']
            );
            showData['total_amt']['advt_rate'] += parseInt(
              this.viewData[index]['fourth_week_advt_amt']
            );
            showData['total_amt']['dis'] += parseInt(
              this.viewData[index]['fourth_week_advt_discnt']
            );
            showData['total_amt']['net'] += parseInt(
              this.viewData[index]['fourth_week_amount']
            );
            showData['total_amt']['cgst'] += parseInt(
              this.viewData[index]['fourth_week_cgst']
            )/this.percentage;
            showData['total_amt']['sgst'] += parseInt(
              this.viewData[index]['fourth_week_sgst']
            )/this.percentage;
            showData['total_amt']['igst'] += parseInt(
              this.viewData[index]['fourth_week_igst']
            );
            showData['total_amt']['round_off'] += parseInt(
              this.viewData[index]['fourth_week_total_amount']
            );
            showData['total_amt']['total'] += parseInt(
              this.viewData[index]['fourth_week_total_amount']
            );
          } 
           if (this.viewData[index]['fifth_week_id'] != null) {
            this.percentage= parseFloat(this.viewData[index]['fifth_week_percentage'])
            showData['fifthweek']['id'] = this.viewData[index]['fifth_week_id'];
            showData['fifthweek']['issue_date'] =
              this.viewData[index]['fifth_week_issue_date'].split(',')[0];
              showData['fifthweek']['issueName'] =
              this.viewData[index]['fifth_week_issue_name'];
            showData['fifthweek']['advt_size'] =
              this.viewData[index]['fifth_week_advt_size'];
            showData['fifthweek']['page_no'] =
              this.viewData[index]['fifth_week_pages_no'];
            showData['fifthweek']['hsn'] = '998363';
            showData['fifthweek']['advt_rate'] =
              this.viewData[index]['fifth_week_advt_amt'];
            showData['fifthweek']['dis'] =
              this.viewData[index]['fifth_week_advt_discnt'];
            showData['fifthweek']['net'] =
              this.viewData[index]['fifth_week_amount'];
               showData['fifthweek']['price'] =
              this.viewData[index]['fifth_week_total'];
            showData['fifthweek']['cgst'] =
              this.viewData[index]['fifth_week_cgst'];
            showData['fifthweek']['sgst'] =
              this.viewData[index]['fifth_week_sgst'];
              showData['fifthweek']['gst_type'] =
              this.viewData[index]['fifth_gst_include_exclude'];
            showData['fifthweek']['igst'] =
            this.viewData[index]['fifth_week_igst'];
            showData['fifthweek']['round_off'] =
              this.viewData[index]['fifth_week_total_amount'];
            showData['fifthweek']['total'] =
              this.viewData[index]['fifth_week_total_amount'];
  
            showData['total_amt']['page_no'] += parseInt(
              this.viewData[index]['fifth_week_pages_no']
            );
            showData['total_amt']['advt_rate'] += parseInt(
              this.viewData[index]['fifth_week_advt_amt']
            );
            showData['total_amt']['dis'] += parseInt(
              this.viewData[index]['fifth_week_advt_discnt']
            );
            showData['total_amt']['net'] += parseInt(
              this.viewData[index]['fifth_week_amount']
            );
            showData['total_amt']['cgst'] += parseInt(
              this.viewData[index]['fifth_week_cgst']
            );
            showData['total_amt']['sgst'] += parseInt(
              this.viewData[index]['fifth_week_sgst']
            );
            showData['total_amt']['igst'] += parseInt(
              this.viewData[index]['fifth_week_igst']
            );
            showData['total_amt']['round_off'] += parseInt(
              this.viewData[index]['fifth_week_total_amount']
            );
            showData['total_amt']['total'] += parseInt(
              this.viewData[index]['fifth_week_total_amount']
            );
          }

          if(!Number.isNaN(showData.total_amt.net)) {
            showData.total_in_words = new ToWords().convert(showData.total_amt.net ,{ currency: true });
          } 

          // showData['total_in_words'] = new ToWords().convert(
          //   showData['total_amt']['total'],
          //   {
          //     currency: true,
          //   }
          // );
          // showData['pre_bal'] = ;
          showData['total'] = showData['total_amt']['total'];
          showData['remaining_amt'] = showData['pre_bal'] + showData['total'];
          // }
  
          this.filteredShowData.push(showData);
          console.log('filtered', this.filteredShowData);
          if (index == this.viewData.length - 1) {
            this.isLoading = false;
          }
          console.log(showData, "this is show data")
        }
      }
    }
    transform(value: any): any {
      // Use moment.js to parse the date string
      const date = moment(value, 'DD/MM/YYYY');
      // Format the date to return only the month name
      return date.format('MMMM');
    }
  
  //   calculateDiscount(dis: any, total: any) {
  //     return Math.round((Number(total) * Number(dis)) / 100);
  // }
  
  
    parseNumber(value) {
      return Number(value) || 0; // Ensures a valid number, prevents NaN
    }
  
    calculateNetAmount(weekData: any): number {
      if (!weekData || !weekData['total']) return 0;
      debugger
      let totalAmount = Number(weekData['total']); // Basic Amount
      let discountPercentage = Number(weekData['dis']) || 0;
  
      // **Step 1: Apply Discount First**
      let discountAmount = (totalAmount * discountPercentage) / 100;
      totalAmount -= discountAmount; // Subtract discount from total
  
      // **Step 2: If GST is Inclusive, Remove GST**
      if (weekData['gst_type'] !== 'gstExclude') {
          let gstAmount = Number(weekData['cgst']) + Number(weekData['sgst']) + Number(weekData['igst']);
          totalAmount -= gstAmount; // Subtract GST only if it's included
      }
  
      return Number(weekData['advt_rate'] );
  }
  
  calculateFinalAmount(weekData: any): number {
    debugger
    if (!weekData || !weekData['total']) return 0;
  
    let totalAmount = Number(weekData['total']); // Base amount
    let discountPercentage = Number(weekData['dis']) || 0;
  
    // **Step 1: Apply Discount**
    let discountAmount = (totalAmount * discountPercentage) / 100;
    totalAmount -= discountAmount; // Subtract discount
  
    // **Step 2: Add GST Components (CGST, SGST, IGST)**
    let cgst = Number(weekData['cgst']) || 0;
    let sgst = Number(weekData['sgst']) || 0;
    let igst = Number(weekData['igst']) || 0;
  
    return Math.round(totalAmount + cgst + sgst + igst);
  }
  convertToWords(amount: any): string {
    return new ToWords().convert(amount, { currency: true }); 
  }
getTotalAmtInWords(showData: any): string {
  // Helper to calculate amount for each week
  function getWeekAmount(week: string): number {
    const w = showData[week] || {};
    return ((+w.price || 0) * (+w.advt_size || 0)) -
           ((+w.dis || 0) * (+w.advt_size || 0)) +
           (+w.cgst || 0) + (+w.sgst || 0) + (+w.igst || 0);
  }

  // Sum all weeks
  const weekTotal = ['firstweek', 'secondweek', 'thirdweek', 'fourthweek', 'fifthweek']
    .reduce((sum, w) => sum + getWeekAmount(w), 0);

  // Add opening balance
  const openingBal = +showData.opening_bal || 0;
  const total = weekTotal + openingBal;

  // Number to words converter
  const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
             'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
             'Seventeen', 'Eighteen', 'Nineteen'];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  function inWords(num: number): string {
    if (num === 0) return 'Zero';
    if (num < 20) return a[num];
    if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
    if (num < 1000) return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + inWords(num % 100) : '');
    if (num < 1000000) return inWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + inWords(num % 1000) : '');
    return '';
  }

  return inWords(Math.floor(total)) + ' Only';
}




grandTotal: number = 0;

calculateGrandTotal() {
  const weeks = ['firstweek', 'secondweek', 'thirdweek', 'fourthweek', 'fifthweek'];
  this.grandTotal = weeks.reduce((total, week) => {
    const data = this.showData[week] || {};
    const price = +data['price'] || 0;
    const advtSize = +data['advt_size'] || 0;
    const discount = +data['dis'] || 0;
    const cgst = +data['cgst'] || 0;
    const sgst = +data['sgst'] || 0;
    const igst = +data['igst'] || 0;

    const amount = (price * advtSize) - (discount * advtSize) + cgst + sgst + igst;
    return total + amount;
  }, 0);
}



  
  }
  